export const SUP_LEADERSHIP_LOADER = {
  desktop: `
<div class="cui cui-grid cui-container">
  <div class="cui-skeleton-paragraph__content -spacing--bottom-96 -spacing--top-40" style="width: 30%">
    <div class="cui-skeleton__item" style="height: 30px"></div>
  </div>
  <!-- Titles -->
  <div class="cui-skeleton-heading -size--large -spacing--bottom-120 -spacing--top-8 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: 50%">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <!-- Quote -->
  <div class="cui-row">
    <div class="cui-col-lg-8 cui-col-md-5 cui-col-sm-4 -spacing--bottom-120">
      <div class="cui-skeleton-paragraph__content -spacing--bottom-24" style="width: 100%">
        <div class="cui-skeleton__item" style="min-height: 132px; max-height: 432px;"></div>
      </div>
      <div class="cui-skeleton-paragraph__content" style="width: 80%">
        <div class="cui-skeleton__item" style="height: 74px"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-3">
      <div class="cui-skeleton-rectangle display-none display-md-block">
        <div class="cui-skeleton__item" style="
          position: absolute;
          width: 100%;
          max-width: 453px;
          max-height: 453px;
          aspect-ratio: 1 / 1;
          top: -88px">
        </div>
      </div>
    </div>
  </div>
  <!-- Leaders Grid -->
  <div class="cui-row -spacing--top-96" >
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16 -spacing--top-4">
        <div class="cui-skeleton__item" style="width: 100%; height: 320px"></div>
        <div class="cui-skeleton__item" style="width: 44%; height: 28px; margin-top: 16px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 20px; margin-top: 4px;"></div>
      </div>
    </div>
  </div>
  <!-- Learn More Section -->
  <div class="cui cui-grid cui-container" style="padding: 4rem 0 108px">
    <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 50%">
      <div class="cui-skeleton__item" style="height: 40px"></div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-8">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 235px"></div>
        </div>
      </div>
      <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-8">
        <div class="cui-skeleton-rectangle display-none display-md-block">
          <div class="cui-skeleton__item" style="width: 100%; height: 235px"></div>
        </div>
      </div>
      <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-8">
        <div class="cui-skeleton-rectangle display-none display-lg-block">
          <div class="cui-skeleton__item" style="width: 100%; height: 235px"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
